import { render, staticRenderFns } from "./ExhibitorPage.vue?vue&type=template&id=5f1fd8cc&"
import script from "./ExhibitorPage.vue?vue&type=script&lang=js&"
export * from "./ExhibitorPage.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VDialog,VSkeletonLoader})
